import React from 'react';
import {
  Modal,
  Button,
  Checkbox,
  Popconfirm,
  Tabs,
  Divider,
  notification,
} from 'antd';
import ImageUploader from './ImageUploader';
import TextArea from './TextArea';
import {
  saveProduct,
  saveProducts,
  uploadImageAction,
  saveListingSettings,
} from '../api';
const TabPane = Tabs.TabPane;

const Field = ({
  id,
  onChange,
  onToggle,
  checked,
  multiples,
  label,
  value,
  input: Input = 'input',
  type,
}) => (
  <>
    <tr>
      <td>
        <Checkbox
          {...(onToggle ? { onChange: onToggle, checked } : { disabled: true })}
          className={!multiples && 'noshow'}
        />
      </td>
      <td>
        <label className="editor__input--label">{label}</label>
      </td>
    </tr>
    <tr>
      <td />
      <td>
        <Input
          id={id}
          {...(type && type === 'checkbox' ? { checked: value } : { value })}
          onChange={onChange}
          className="editor__input"
        />
      </td>
    </tr>
  </>
);

class EditListingModal extends React.Component {
  constructor(props) {
    super(props);
    const {
      selections: [values = {}],
    } = props;
    const images = values.images || [];
    const custom = values.custom || {};

    this.state = {
      fileList: images,
      values: { ...values, ...custom },
      multiples: props.selections && props.selections.length > 1,
      loading: false,
      titleChecked: false,
      imageChecked: false,
      descriptionChecked: false,
      priceChecked: false,
      mvnoPriceChecked: false,
      mvnoListedChecked: false,
      duPriceChecked: false,
      duListedChecked: false,
      duTitleChecked: false,
      marketplace: '',
      settingId: '',
      themeId: '',
    };
  }

  handleSubmit = async (e) => {
    const { multiples, fileList, values } = this.state;
    const { selections = [] } = this.props;

    if (multiples) {
      // Return the relevant id for the api from here
      let data = {};
      if (this.state.titleChecked) {
        data.title = values.title;
      }
      if (this.state.descriptionChecked) {
        data.description = values.description;
      }
      if (this.state.imageChecked) {
        data.images = fileList;
      }
      if (this.state.priceChecked) {
        data.price = values.price;
      }
      if (this.state.mvnoPriceChecked) {
        data.mvnoPrice = values.mvnoPrice;
      }
      if (this.state.mvnoListedChecked) {
        data.mvnoListed = values.mvnoListed;
      }
      if (this.state.duPriceChecked) {
        data.duPrice = values.duPrice;
      }
      if (this.state.duListedChecked) {
        data.duListed = values.duListed;
      }
      if (this.state.duTitleChecked) {
        data.duTitle = values.duTitle;
      }

      try {
        await this.submitMultiple(selections, data);
        notification.success({ message: 'Saved items' });
      } catch (err) {
        notification.error({
          message: 'Error saving items',
        });
      }
      return;
    }

    const [first] = selections;

    try {
      await this.submitSingle(first.sku, {
        title: values.title,
        description: values.description,
        asin: values.asin,
        ebaySku: values.ebaySku,
        epid: values.epid,
        price: values.price,
        images: fileList,
        mvnoPrice: values.mvnoPrice,
        mvnoListed: values.mvnoListed,
        duPrice: values.duPrice,
        duListed: values.duListed,
        duTitle: values.duTitle,
        itemId: first.custom.itemId,
      });
      notification.success({ message: `Saved ${values.sku}` });
    } catch (err) {
      notification.error({
        message: `Error saving ${values.sku}`,
      });
    }
  };

  submitSingle = async (sku, data) => {
    this.setState({ loading: true });
    await saveProduct({ ...data, sku });
    this.submitted();
  };

  submitMultiple = async (items, data) => {
    this.setState({ loading: true });
    await saveProducts(
      items.map((item) => ({
        ...data,
        sku: item.sku,
        itemId: item.custom.itemId,
      }))
    );
    this.submitted();
  };

  submitted = () => {
    this.setState({ loading: false });
    this.props.onClose('edited');
  };

  toggleField = (fieldName) => (e) => {
    this.setState({ [fieldName]: e.target.checked });
  };

  changeField = (fieldName) => (e) => {
    if (e.persist) e.persist();
    const value = e.target ? e.target.value : e;

    this.setState((prevState) => {
      return { values: { ...prevState.values, [fieldName]: value } };
    });
  };

  changeCheckbox = (fieldName) => (e) => {
    if (e.persist) e.persist();
    const value = e.target.checked;

    this.setState((prevState) => {
      return { values: { ...prevState.values, [fieldName]: value } };
    });
  };

  updateFileList = (list) => {
    this.setState({ fileList: list });
  };

  imageOrderToggle = (e) => {
    this.setState((state) => {
      return {
        imageOrdering: !state.imageOrdering,
      };
    });
  };

  handleSubmitSettings = async (e) => {
    e.preventDefault();
    const { marketplace, settingId, themeId } = this.state;
    const { selections = [] } = this.props;

    try {
      await saveListingSettings(
        marketplace,
        settingId,
        themeId,
        selections.map((p) => p.sku)
      );
      notification.success({
        message: `Saved listing settings for ${selections.length} item(s)`,
      });
    } catch (err) {
      notification.error({
        message: 'Error saving listing settings',
      });
    }
  };

  onChangeMarketplace = (e) => {
    const { channels, selections: [first] = [] } = this.props;
    const marketplace = e.target.value;
    const currentChannel = channels.find(
      (channel) => channel.id === marketplace
    );
    if (currentChannel) {
      const settings = currentChannel.products.find(
        (p) => p.sku.trim() === first.sku
      );
      this.setState({
        marketplace,
        settingId: settings ? settings.listSettingId : '',
        themeId: settings ? settings.listThemeId : '',
      });
    } else {
      this.setState({ marketplace, settingId: '', themeId: '' });
    }
  };

  onChangeSetting = (e) => {
    this.setState({ settingId: e.target.value });
  };

  onChangeTheme = (e) => {
    this.setState({ themeId: e.target.value });
  };

  render() {
    const {
      fileList,
      values,
      multiples,
      loading,
      titleChecked,
      descriptionChecked,
      priceChecked,
      mvnoPriceChecked,
      mvnoListedChecked,
      duPriceChecked,
      duListedChecked,
      duTitleChecked,
      imageChecked,
    } = this.state;
    const { channels, settings, themes } = this.props;

    let footer = [
      <Button key="back" onClick={this.props.onClose}>
        Cancel
      </Button>,
      <Button
        key="submit"
        loading={loading}
        type="primary"
        onClick={this.handleSubmit}
      >
        Save
      </Button>,
    ];

    if (multiples) {
      footer = [
        <Button key="back" onClick={this.props.onClose}>
          Cancel
        </Button>,
        <Popconfirm
          key="submit"
          title="You are editing for multiple selections. Are you sure you want to save?"
          onConfirm={this.handleSubmit}
          okText="Yes"
          cancelText="No"
        >
          <Button type="primary" loading={loading}>
            Save
          </Button>
        </Popconfirm>,
      ];
    }

    return (
      <div>
        <Modal
          title="Edit Listing"
          visible={this.props.editing}
          onCancel={this.props.onClose}
          centered={true}
          footer={footer}
        >
          <Tabs defaultActiveKey="detail">
            <TabPane tab="Item Detail" key="detail">
              <table id="table1">
                <tbody>
                  <Field
                    onToggle={this.toggleField('titleChecked')}
                    checked={titleChecked}
                    multiples={multiples}
                    label={
                      <span>
                        Listing Title (
                        {(values.title && values.title.length) || 0})
                      </span>
                    }
                    id="edit1"
                    value={values.title}
                    onChange={this.changeField('title')}
                  />
                  <Field
                    onToggle={this.toggleField('descriptionChecked')}
                    checked={descriptionChecked}
                    multiples={multiples}
                    label="Listing Description"
                    id="edit2"
                    value={values.description}
                    onChange={this.changeField('description')}
                    input={TextArea}
                  />
                  <Field
                    onToggle={this.toggleField('priceChecked')}
                    checked={priceChecked}
                    multiples={multiples}
                    label="Price"
                    id="edit3"
                    value={values.price}
                    onChange={this.changeField('price')}
                  />
                  <Field
                    multiples={multiples}
                    label="ASIN"
                    id="edit4"
                    value={values.asin}
                    onChange={this.changeField('asin')}
                  />
                  <Field
                    multiples={multiples}
                    label="EBAY SKU"
                    id="edit5"
                    value={values.ebaySku}
                    onChange={this.changeField('ebaySku')}
                  />
                  <Field
                    multiples={multiples}
                    label="EPID"
                    id="edit6"
                    value={values.epid}
                    onChange={this.changeField('epid')}
                  />
                  <Field
                    onToggle={this.toggleField('mvnoPriceChecked')}
                    checked={mvnoPriceChecked}
                    multiples={multiples}
                    label="MVNO Price"
                    id="edit7"
                    value={values.mvnoPrice}
                    onChange={this.changeField('mvnoPrice')}
                  />
                  <Field
                    onToggle={this.toggleField('mvnoListedChecked')}
                    checked={mvnoListedChecked}
                    multiples={multiples}
                    label="MVNO Listed?"
                    id="edit8"
                    value={values.mvnoListed}
                    onChange={this.changeCheckbox('mvnoListed')}
                    input={Checkbox}
                    type="checkbox"
                  />
                  <Field
                    onToggle={this.toggleField('duTitleChecked')}
                    checked={duTitleChecked}
                    multiples={multiples}
                    label="Device Upgrades Title"
                    id="edit9"
                    value={values.duTitle}
                    onChange={this.changeField('duTitle')}
                  />
                  <Field
                    onToggle={this.toggleField('duPriceChecked')}
                    checked={duPriceChecked}
                    multiples={multiples}
                    label="Device Upgrades Price"
                    id="edit10"
                    value={values.duPrice}
                    onChange={this.changeField('duPrice')}
                  />
                  <Field
                    onToggle={this.toggleField('duListedChecked')}
                    checked={duListedChecked}
                    multiples={multiples}
                    label="Device Upgrades Listed?"
                    id="edit11"
                    value={values.duListed}
                    onChange={this.changeCheckbox('duListed')}
                    input={Checkbox}
                    type="checkbox"
                  />
                  <tr>
                    <td>
                      <Checkbox
                        onChange={this.toggleField('imageChecked')}
                        checked={imageChecked}
                        className={!multiples && 'noshow'}
                      />
                    </td>
                    <ImageUploader
                      action={uploadImageAction(values.sku)}
                      fileList={fileList}
                      loading={loading}
                      updateFileList={this.updateFileList}
                    />
                  </tr>
                </tbody>
              </table>
            </TabPane>
            <TabPane tab="Settings / Themes" key="settings">
              <select
                value={this.state.marketplace}
                onChange={this.onChangeMarketplace}
              >
                <option>Select a Marketplace</option>
                {channels.map((channel) => (
                  <option value={channel.id} key={channel.id}>
                    {channel.name}
                  </option>
                ))}
              </select>
              {this.state.marketplace && (
                <div>
                  <Divider />
                  <label className="editor__input--label">
                    Please select the listing setting to apply to your selected
                    products.
                  </label>
                  <div className="editor__input--select">
                    <select
                      value={this.state.settingId}
                      onChange={this.onChangeSetting}
                    >
                      <option value="" disabled>
                        Listing Setting
                      </option>
                      {settings.map((setting) => (
                        <option key={setting.id} value={setting.id}>
                          {setting.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <label className="editor__input--label">
                    Please select the listing theme to apply to your selected
                    products.
                  </label>
                  <div className="editor__input--select">
                    <select
                      value={this.state.themeId}
                      onChange={this.onChangeTheme}
                    >
                      <option value="" disabled>
                        Listing Theme
                      </option>
                      {themes.map((theme) => (
                        <option key={theme.id} value={theme.id}>
                          {theme.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <Button type="primary" onClick={this.handleSubmitSettings}>
                    Save Settings
                  </Button>
                </div>
              )}
            </TabPane>
          </Tabs>
        </Modal>
      </div>
    );
  }
}

export default EditListingModal;
